import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  image: string;
  date: string;
  readTime: string;
  tags?: string[];
}

export default function ArticleCard({ slug, title, excerpt, image, date, readTime, tags }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${slug}`}
      className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-amber-200/60 transition-all duration-300 cursor-pointer"
    >
      <div className="aspect-[16/10] overflow-hidden">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          title={title}
        />
      </div>
      <div className="p-4 md:p-5">
        <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {date}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {readTime}
          </span>
        </div>
        <h3 className="text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-amber-600 transition-colors duration-200">
          {title}
        </h3>
        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
          {excerpt}
        </p>
        {tags && tags.length > 0 && (
          <div className="flex items-center gap-1.5 flex-wrap">
            {tags.slice(0, 3).map((tag) => (
              <span key={tag} className="px-2 py-0.5 text-xs rounded-md bg-background-100 text-foreground-600">
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </Link>
  );
}